import { RoutePath } from 'data';
import { Form, ReduxState } from 'interface';
import React, { useEffect, useState } from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { useHistory, useParams } from 'react-router';
import { getFormAnswersCount } from 'scripts/db';
import { WSData } from 'scripts/storage';
import FormCard, { FormCardProps } from 'ucheck/components/formCard/formCard.index';
import './wsDetail.style.scss';

const WorkspaceDetail: React.FC<ConnectedProps<typeof connector> & { onRefresh: () => Promise<boolean> }> = function (
    props: ConnectedProps<typeof connector> & { onRefresh: () => Promise<boolean> },
) {
    const lang = props.lang.wsPanel;
    const { wsId } = useParams<any>();
    const [forms, setForms] = useState<FormCardProps[]>();
    const [title, setTitle] = useState('');
    const [refreshing, setRefreshing] = useState(false);
    const history = useHistory();

    useEffect(() => {
        const data = WSData.get();
        if (data) {
            const forms: FormCardProps[] = [];
            const allForms: Form[] = [];
            const workspace = data.find((i) => i.id === Number(wsId));
            if (workspace) {
                const promises: Promise<any>[] = [];
                workspace.forms.map((i) => {
                    promises.push(getFormAnswersCount(i.id));
                    allForms.push(i);
                });
                Promise.all(promises).then((res: number[]) => {
                    res.map((i, index) => forms.push({ form: allForms[index], answerCount: i }));
                    forms.sort((a, b) => Number(a.form?.modified_at) - Number(b.form?.modified_at));
                    setForms([...forms]);
                    setTitle(workspace.title);
                });
            }
        }
    }, [props.workspaces]);

    function onRefreshHandler() {
        if (refreshing) return;
        setRefreshing(true);
        props.onRefresh().then((res) => {
            setRefreshing(false);
        });
    }

    return (
        <div className="ucheck-kiosk-panel-ws-detail">
            <div className="header-ws-detail d-flex align-items-center justify-content-between">
                <div className="d-flex align-items-center">
                    <i onClick={() => history.push(RoutePath.dashboard.index)} className="material-icons-outlined">
                        east
                    </i>
                    <h3>{title}</h3>
                </div>
                <div className="d-flex align-items-center">
                    <i onClick={onRefreshHandler} className={`material-icons-outlined ${refreshing ? 'rotate' : ''}`}>
                        {refreshing ? 'sync' : 'refresh'}
                    </i>
                    <i
                        onClick={() => history.push(RoutePath.dashboard.notification)}
                        className="material-icons-outlined notification-icon"
                    >
                        notifications
                    </i>
                </div>
            </div>
            {props.expire ? (
                <p className="expire-error">
                    کاربر محترم به منظور فعالسازی مجدد بروزرسانی فرم ها و فضای های کاری لطفا یک بار از حساب کاربری خود
                    خارج و مجددا وارد شوید.
                </p>
            ) : null}
            <div className="list-container">
                <h4>{lang.forms}</h4>
                {forms && props.workspaces ? (
                    forms.length ? (
                        forms.map((i, index) => <FormCard key={index} {...i} />)
                    ) : (
                        <p>{lang.panel.emptyStateFormInWs}</p>
                    )
                ) : (
                    <>
                        <FormCard />
                        <FormCard />
                        <FormCard />
                        <FormCard />
                        <FormCard />
                    </>
                )}
            </div>
        </div>
    );
};

const mapStateToProps = (state: ReduxState) => ({
    workspaces: state.workspacesData,
    lang: state.lang,
    expire: state.expired,
});

const connector = connect(mapStateToProps);
export default connector(WorkspaceDetail);
